import React, { useState, useEffect } from 'react'
import { Card, Radio, Checkbox, Space } from 'antd';

const W4FormStep1 = (props) => {
  const {
    w4Form, setW4Form, resetW4,
    hasErrors, setHasErrors,
    focusConfirmExemptionConditionsMetInd, disableAll
  } = props;

  const [maritalStatus, setMaritalStatus] = useState(null);
  const [confirmExemption, setConfirmExemption] = useState(false);

  useEffect(() => {
    if (w4Form != null) {
      if (w4Form.isSingle) {
        setMaritalStatus(1);
      }
      if (w4Form.isMarried) {
        setMaritalStatus(2);
      }
      if (w4Form.isHeadOfHouseHold) {
        setMaritalStatus(3);
      }
      if (w4Form.claimExemptionFromWithholdingInd) {
        setMaritalStatus(null);
      }
      setConfirmExemption(w4Form.confirmExemptionConditionsMetInd);
    }
  }, [w4Form]);

  useEffect(() => {
    setW4Form({ ...w4Form, ...{ confirmExemptionConditionsMetInd: confirmExemption } });
    if (confirmExemption) {
      setHasErrors({ ...hasErrors, ...{ confirmExemptionConditionsMetInd: false } })
    }
  }, [confirmExemption]);

  return (
    <Card type="inner" title={'Step 1: Marital Status'}>
      <p>Marital Status</p>
      <Radio.Group
        value={maritalStatus}
        onChange={(e) => {
          var payload = {
            isSingle: (e.target.value == 1 ? true : false),
            isMarried: (e.target.value == 2 ? true : false),
            isHeadOfHouseHold: (e.target.value == 3 ? true : false)
          }
          setW4Form({ ...w4Form, ...payload });
        }}
        disabled={w4Form.claimExemptionFromWithholdingInd || disableAll}
      >
        <Space direction="vertical">
          <Radio value={1}>Single or Married filing separately</Radio>
          <Radio value={2}>Married filing jointly or Qualifying widow(er)</Radio>
          <Radio value={3}>Head of household (Select only if you are unmarried and pay more than half the costs of keeping up a home for yourself and a qualifying individual.)
          </Radio>
        </Space>
      </Radio.Group><br />
      <div style={{ marginTop: '1em' }}>
        <Checkbox
          checked={w4Form.claimExemptionFromWithholdingInd}
          onChange={(e) => {
            resetW4(e.target.checked)
          }}
          disabled={disableAll}
        >
          I claim exemption from withholding
        </Checkbox><br />
      </div>
      {
        (w4Form.claimExemptionFromWithholdingInd) ?
          (
            <>
              <div>
                <Checkbox
                  ref={focusConfirmExemptionConditionsMetInd}
                  checked={confirmExemption}
                  onChange={(e) => {
                    setConfirmExemption(e.target.checked)
                  }}
                  disabled={disableAll}>
                  I certify that I meet BOTH of the following conditions for exemption:<br />
                </Checkbox>
              </div>
              <p style={{ marginLeft: '2em' }}>
                {
                  (hasErrors.confirmExemptionConditionsMetInd) ?
                    (<p style={{ color: 'red' }}>This confirmation is required.</p>) : (<></>)
                }
                1. Last year I had a right to a refund of ALL Federal income tax withheld because I had NO tax liability.<br />
                2. This year I expect a refund of ALL Federal Income tax withheld because I expect to have NO tax liability.
              </p>
            </>
          ) : (<></>)
      }
    </Card >
  )
}
export default W4FormStep1
